import { axiosInstance } from '../../../api'
import { ENDPOINTS } from '../endpoints'
import { EulaLatest } from './models'

const { AUTH: { EULA, EULA_LATEST } } = ENDPOINTS

const mapEulaLatest = (data: Record<string, unknown>): EulaLatest => ({
  version: Number(data.version ?? data.Version),
  content: (data.content ?? data.Content) as string | undefined,
})

export const eulaApi = {
  async getLatestAsync(): Promise<EulaLatest> {
    const response = await axiosInstance.get(EULA_LATEST)
    return mapEulaLatest(response.data as Record<string, unknown>)
  },

  async acceptAsync(): Promise<void> {
    await axiosInstance.post(EULA)
  },
}
